import React from 'react';
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';
import Icon from '../../containers/assets/warning-icon.png';

const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  z-index: 1001;
`;

const AlertWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: ${p => p.maxWidth || 400}px;
  position: fixed;
  z-index: 1002;
  top: 300px;
  left: 50%;
  margin-left: ${p => -((p.maxWidth || 400) / 2)}px;
  padding: 32px 32px 24px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

const AlertBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const FullWidth = styled.div`
  flex: 1;
`;

const AlertTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const AlertMessage = styled.div`
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;
`;

const AlertButtons = styled.div`
  margin-top: 20px;
  float: right;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const AlertButton = styled.div`
  background: #5c91f5;
  border: 1.5px solid #5c91f5;
  border-radius: 4px;
  color: #ffffff;
  display: block;
  padding: 6px 14px;
  cursor: pointer;
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  ${p => p.isWhite && `
    background: #fff;
    border-color: #d5d9dd;
    color: rgba(0, 27, 59, 0.94);
  `}
`;

const WarningAlert = ({
  title,
  message,
  onCancel,
  showCancel = true,
  onSuccess,
  successButtonText = 'Yes',
  maxWidth,
}) => (
  <Fragment>
    <AlertOverlay />
    <AlertWrapper maxWidth={maxWidth}>
      <AlertBody>
        <div><img src={Icon} alt="" /></div>
        <FullWidth>
          <AlertTitle>{title}</AlertTitle>
          <AlertMessage>{message}</AlertMessage>
          <AlertButtons>
            {showCancel && <AlertButton onClick={onCancel} isWhite={true}>No</AlertButton>}
            <AlertButton onClick={onSuccess}>{successButtonText}</AlertButton>
          </AlertButtons>
        </FullWidth>
      </AlertBody>
    </AlertWrapper>
  </Fragment>
);

export default WarningAlert;



// WEBPACK FOOTER //
// ./src/components/alerts/warning.js